import React from 'react';
import { Box, IconButton, Tooltip } from '@mui/material';
import SettingsRoundedIcon from '@mui/icons-material/SettingsRounded';
import SwapVerticalCircleRoundedIcon from '@mui/icons-material/SwapVerticalCircleRounded';
import SwapHorizontalCircleRoundedIcon from '@mui/icons-material/SwapHorizontalCircleRounded';
import PanoramaVerticalSelectIcon from '@mui/icons-material/PanoramaVerticalSelect';
import PanoramaHorizontalSelectIcon from '@mui/icons-material/PanoramaHorizontalSelect';
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';

interface PageToolbarProps {
  id: string;
  isOrientedHorizontally: boolean;
  isOrientedHorizontallySinglePage: boolean;
  showRemovePageButton: boolean;
  onClickOrientation: () => void;
  onClickRemove: () => void;
  onClickSettings: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  onClickPageOrientation: () => void;
}

export const PageToolbar = ({
  isOrientedHorizontally,
  isOrientedHorizontallySinglePage,
  showRemovePageButton,
  onClickSettings,
  onClickRemove,
  onClickOrientation,
  onClickPageOrientation,
}: PageToolbarProps) => {
  return (
    <Box
      display='flex'
      alignItems={'center'}
      gap='16px'
      justifyContent={'flex-end'}
      marginBottom={'30px'}
      width={'100%'}
    >
      <Tooltip title='Page Settings' arrow>
        <IconButton aria-label='page settings' onClick={e => onClickSettings(e)}>
          <SettingsRoundedIcon color='primary' />
        </IconButton>
      </Tooltip>
      <Tooltip title='Page Orientation' arrow>
        <IconButton aria-label='page orientation' onClick={onClickOrientation}>
          {!isOrientedHorizontally ? (
            <SwapHorizontalCircleRoundedIcon color='primary' />
          ) : (
            <SwapVerticalCircleRoundedIcon color='primary' />
          )}
        </IconButton>
      </Tooltip>
      <Tooltip title='Single Page Orientation' arrow>
        <IconButton aria-label='page orientation' onClick={onClickPageOrientation}>
          {!isOrientedHorizontallySinglePage ? (
            <PanoramaHorizontalSelectIcon color='primary' />
          ) : (
            <PanoramaVerticalSelectIcon color='primary' />
          )}
        </IconButton>
      </Tooltip>
      {showRemovePageButton && (
        <Tooltip title='Remove page' arrow>
          <IconButton aria-label='page settings' onClick={onClickRemove}>
            <DeleteRoundedIcon color='primary' />
          </IconButton>
        </Tooltip>
      )}
    </Box>
  );
};
